import { SVGProps, Ref, forwardRef, useId } from 'react';

export const EsiaGrayscaleSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => {
    const _uniqueId = useId();
    return (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <path
                d="M14.6 5.532c-.058-.756-.635-1.725-1.212-2.19a22 22 0 0 0-2.02-1.318A22 22 0 0 0 9.235.9a3.1 3.1 0 0 0-1.23-.233C7.582.658 7.163.737 6.773.9a23 23 0 0 0-2.135 1.124c-1.115.678-2.02 1.318-2.02 1.318-.48.405-.842.928-1.055 1.513a.16.16 0 0 0 .153.212h.922c.124 0 .236-.07.301-.175.164-.267.371-.508.615-.712 0 0 .747-.524 1.667-1.08q.857-.508 1.763-.922A2.5 2.5 0 0 1 8 1.988c.348-.007.694.058 1.016.19q.906.413 1.763.922.864.495 1.667 1.08c.476.382.953 1.176 1 1.796 0 0 .112.922.127 2.014q0 1.012-.11 2.018a2.94 2.94 0 0 1-1.017 1.796s-.746.54-1.667 1.096q-.857.508-1.763.922a2.5 2.5 0 0 1-1.016.19 2.6 2.6 0 0 1-1.016-.185 19 19 0 0 1-1.763-.922 20 20 0 0 1-1.667-1.097 2.9 2.9 0 0 1-.6-.704.35.35 0 0 0-.298-.17H1.72a.158.158 0 0 0-.151.214c.23.582.64 1.166 1.05 1.496 0 0 .904.679 2.02 1.338a22 22 0 0 0 2.134 1.124c.39.158.81.235 1.23.226.422.01.841-.07 1.231-.232q1.098-.504 2.135-1.124c1.115-.679 2.02-1.337 2.02-1.337a3.6 3.6 0 0 0 1.23-2.19q.132-1.228.135-2.462c-.02-1.331-.154-2.455-.154-2.455"
                fill={`url(#${_uniqueId}paint0_linear_9139_2432)`}
                suppressHydrationWarning
            />
            <path
                d="M1.253 6.387c0-.162.132-.293.294-.293h4.546c.162 0 .294.131.294.293v.88a.293.293 0 0 1-.294.294h-4.84z"
                fill="#72777D"
            />
            <path
                d="M1.253 8.44h9.24c.162 0 .293.132.293.294v.88a.293.293 0 0 1-.293.293H1.547a.293.293 0 0 1-.294-.293z"
                fill="#A3ABB2"
            />
            <defs>
                <linearGradient
                    id={`${_uniqueId}paint0_linear_9139_2432`}
                    x1={8.123}
                    y1={0.667}
                    x2={8.123}
                    y2={15.333}
                    gradientUnits="userSpaceOnUse"
                    suppressHydrationWarning
                >
                    <stop stopColor="#72777D" />
                    <stop offset={0.354} stopColor="#72777D" />
                    <stop offset={0.688} stopColor="#A3ABB2" />
                    <stop offset={1} stopColor="#A3ABB2" />
                </linearGradient>
            </defs>
        </svg>
    );
});
EsiaGrayscaleSize16Glyph.displayName = 'EsiaGrayscaleSize16Glyph';
